import { useEffect } from 'react';
import { insightChatRoomName, type InsightChatEvent } from '@wundo/shared/insightChat.ts';
import { connectRoom } from '@wundo/client/roomSocket.ts';
import { isInsightChatEvent } from './insightChatEvent.ts';

/**
 * Listen to a run's conversation for as long as the page is open.
 *
 * `onEvent` and `onReconnect` are expected to be stable, so the socket is not
 * rebuilt on every render. `onReconnect` says the conversation should be read
 * again: the socket carries no backlog.
 */
export function useInsightChatSocket(
  conversationId: string | null | undefined,
  onEvent: (event: InsightChatEvent) => void,
  onReconnect: () => void,
): void {
  useEffect(() => {
    if (!conversationId) return;

    return connectRoom(
      insightChatRoomName(conversationId),
      (data) => {
        if (isInsightChatEvent(data)) onEvent(data);
      },
      onReconnect,
    );
  }, [conversationId, onEvent, onReconnect]);
}
